/**
 * App Routes
 * Centralized route paths for AllTuc
 */

// Public Routes
export const ROUTES = {
  // Auth
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  REGISTER_SUCCESS: '/register-success',
  BENEFITS: '/benefits',

  // Home & Catalog
  HOME: '/home',
  CATALOG: '/catalog',
  FAVORITES: '/favorites',
  WISHLIST: '/wishlist',

  // Product
  PRODUCT_DETAIL: '/product/:id',
  PRODUCT_REVIEWS: '/product/:id/reviews',

  // Cart & Checkout
  CART: '/cart',
  SHIPPING: '/shipping',
  PAYMENT: '/payment',
  CHECKOUT_REVIEW: '/checkout-review',
  SUCCESS: '/success',

// Orders
ORDERS_HISTORY: '/orders-history',
ORDER_DETAIL: '/order/:id',
TRACKING: '/tracking',

  // User
  PROFILE: '/profile',
  ADDRESSES: '/addresses',

  // Club & Wallet
  CLUB: '/club',
  WALLET: '/wallet',
  WALLET_TOPUP: '/wallet/topup',
  WALLET_TOPUP_REVIEW: '/wallet/topup/review',
  WALLET_HISTORY: '/wallet/history',

  // Chat
  CHATS: '/chats',
  CHAT_DETAIL: '/chats/:chatId',

  // Content
  BLOG: '/blog',
  BLOG_POST: '/blog/:id',
  FAQ: '/faq',
  LEGAL: '/legal/:type',
  TUCCOINS_INFO: '/tuccoins-info',
  MEMBERSHIP_PLANS: '/planes',

  // Shops
  SHOPS_DIRECTORY: '/tiendas',
  SHOP_PUBLIC: '/tienda/:slug',
  SHOP_REVIEWS: '/tienda/:slug/reviews',

  // Onboarding
  ONBOARDING: '/onboarding',

  // Partner Routes
  PARTNER: {
    BASE: '/partner',
    REGISTRATION: '/partner/registro',
    DASHBOARD: '/partner/dashboard',
    NEW_PRODUCT: '/partner/producto/nuevo',
    PRODUCTS: '/partner/productos',
    SERVICES: '/partner/servicios',
    REVIEWS: '/partner/reviews',
    FINANCE: '/partner/finanzas',
  },

// Admin Routes
ADMIN: {
BASE: '/admin',
OPERATIONS: '/admin/operations',
},

  // Redirects
  ROOT: '/',
  NOT_FOUND: '*',
} as const;

// Query Params
export const QUERY_PARAMS = {
  CATEGORY: 'category',
  SEARCH: 'q',
  FILTER: 'filter',
  SORT: 'sort',
  PAGE: 'page',
} as const;

// External URLs
export const EXTERNAL_URLS = {
  WHATSAPP_SUPPORT: 'https://wa.me/5493815550000',
  DEFAULT_REDIRECT: 'https://alltuc.com',
} as const;

// Route validation patterns
export const ROUTE_PATTERNS = {
  PRODUCT_ID: /^[a-zA-Z0-9-_]+$/,
  SLUG: /^[a-zA-Z0-9-_]+$/,
  ORDER_ID: /^[a-zA-Z0-9]+$/,
} as const;
